<div *ngIf="user">
	<mat-card class="card-block">
		<mat-card-header>
			<mat-card-title>Arbetsgivare</mat-card-title>
		</mat-card-header>
		<mat-card-content>
			<form [formGroup]="employeeIdForm.controls" (ngSubmit)="setEmployeeId()">
				<label>Anställningsnummer</label>
				<div class="row">
					<div class="col-9">
						<input
							type="text"
							class="form-control"
							formControlName="employeeId"
						/>
					</div>
					<div class="col-3">
						<input
							type="submit"
							class="btn btn-primary btn-block"
							value="Spara"
							[disabled]="!employeeIdForm.isValid()"
						/>
					</div>
				</div>
				<div style="padding-top: 6px">
					<form-state [form]="employeeIdForm"></form-state>
				</div>
			</form>
			<form
				[formGroup]="employerForm.controls"
				(ngSubmit)="setEmployer()"
				style="margin-top: 12px"
			>
				<label>Arbetsgivare</label>
				<div class="row">
					<div class="col-9">
						<select class="form-control" formControlName="employerId">
							<option value="">Ingen arbetsgivare</option>
							<option
								*ngFor="let company of companies"
								[value]="company.id"
							>
								{{ company.name }}
							</option>
						</select>
					</div>
					<div class="col-3">
						<input
							type="submit"
							class="btn btn-primary btn-block"
							value="Spara"
							[disabled]="!employerForm.isValid()"
						/>
					</div>
				</div>
				<div style="padding-top: 6px">
					<form-state [form]="employerForm"></form-state>
				</div>
			</form>
		</mat-card-content>
	</mat-card>
</div>
